export default {
  path: "/main/system/user",
  name: "User",
  component: () => import("@/views/main/System/User/user.vue"),
  children: []
};
